<template>
  <div class="action-btns d-flex">
    <b-button
      variant="danger"
      block
      class="mr-1"
      id="clear-all"
      :disabled="isEnable || $loading"
      @click="clearBill"
      >Clear All</b-button
    >
    <b-button
      variant="success"
      block
      class="mr-1"
      id="checkout-btn"
      @click="checkout"
      :disabled="isEnable || $loading"
      >Checkout</b-button
    >
    <!-- Message Box -->
    <message-box
      :open="error"
      @close-message="flushError"
      :message="errorMsg"
    ></message-box>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as msg from "../message";
import MessageBox from "../components/MessageBox";
// import * as helper from "../helper";

export default {
  name: "gift-voucher-action-btns",
  // props: { refundMode: Boolean },
  components: {
    MessageBox,
  },
  data() {
    return {
      error: false,
      errorMsg: {
        btnText: "",
        text: "",
        type: "",
        info: "",
      },
    };
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    isEnable() {
      let temp = true;
      if (parseInt(this.state.giftVoucher.cart.total_item_in_cart) > 0)
        temp = false;
      return temp;
    },
  },
  methods: {
    checkout() {
      if (
        this.state.system.settings.vendor_app_menu.customer_logins.DEFAULT
          .status == 1 &&
        this.state.system.settings.vendor_login_details.c_id ==
          this.customerData.c_id
      ) {
        this.error = true;
        this.errorMsg.text = msg.CUSTOMER_MANDATORY;
        this.errorMsg.btnText = "Continue";
        this.errorMsg.info = msg.CUSTOMER_MANDATORY_INFO;
        this.errorMsg.type = "session";
      } else {
        this.$loading = true;
        this.$store
          .dispatch("giftVoucher/checkout")
          .then(() => {
            this.$loading = false;
            this.$store.commit("giftVoucher/setGvSale", true);
            this.$router.push("checkout");
          })
          .catch(() => (this.$loading = false));
      }
    },
    clearBill() {
      this.$loading = true;
      this.$store
        .dispatch("giftVoucher/cartActions", {
          selected: [],
          gv_group_id: 0,
          action_type: "remove_cart",
        })
        .then(() => {
          this.$store.commit("billing/resetBilling");
          this.$loading = false;
        })
        .catch(() => (this.$loading = false));
    },
    flushError(val) {
      this.error = val;
      if (this.errorMsg.type == "SessionOpen") {
        this.session.openBox = true;
      }
      this.errorMsg = {
        btnText: "",
        text: "",
        type: "",
      };
    },
  },
};
</script>
